import { ConfigurationSetting, GetConfigurationSettingResponse } from '@azure/app-configuration'

export interface IAzureConfig<T> extends Omit<GetConfigurationSettingResponse, 'value'> {
  value: T
}

export function azureFormat<T>(setting: ConfigurationSetting<string>): IAzureConfig<T> {
  const formatted: Partial<IAzureConfig<T>> = {
    ...setting,
    value: JSON.parse(setting.value)
  }

  return formatted as IAzureConfig<T>
}
